module.exports = __webpack_public_path__ + "img/recht-mang_w.48fffa63.svg";